<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ completed: number; total: number }>()

const text = computed(() => `${props.completed}/${props.total}`)
</script>

<template>
  <div class="count">{{ text }}</div>
</template>

<style scoped>
.count {
  color: color-mix(in srgb, var(--pl-color-text, #0f172a) 80%, #64748b);
  font-size: 0.9rem;
  font-weight: 600;
}
</style>
